<template>
  <div>
    <stats-section has-columns>
      <stats-campaigns-box
        class="column is-3 mr-50"
        label="Leads"
        cost-label="Cost Per Lead"
        :count="chart.leads"
        :cost-amount="costPerLead"
        :chart-data="leadChartData"
        :chart-data-is-loaded="true"
      />

      <stats-campaigns-box
        class="column is-3 mx-50"
        label="Contracted"
        cost-label="Cost Per Contracted"
        :count="chart.contracted"
        :cost-amount="costPerContracted"
        :chart-data="contractedChartData"
        :chart-data-is-loaded="true"
      />

      <stats-campaigns-box
        class="column is-3 ml-50"
        label="Closed"
        cost-label="Cost Per Closed"
        :count="chart.closed"
        :cost-amount="costPerClosed"
        :chart-data="closedChartData"
        :chart-data-is-loaded="true"
      />

      <stats-campaigns-profit-box
        class="column is-5 mr-50"
        label="Projected Profit"
        :dollar="projectProfitDollar"
        :roi="projectProfitRoi"
        :profit="parseFloat(chart.projected_profit)"
      />

      <stats-campaigns-profit-box
        class="column is-5 ml-50"
        label="Actual Profit"
        :dollar="actualProfitDollar"
        :roi="actualProfitRoi"
        :profit="parseFloat(chart.actual_profit)"
        :projected-profit-percentage="parseFloat(chart.projected_profit_percentage_amount)"
        :actual-profit-percentage="parseFloat(chart.actual_profit_percentage_amount)"
      />
    </stats-section>
  </div>
</template>

<script>
import StatsBox from "./StatsBox.vue";
import StatsCampaignsProfitBox from "./StatsCampaignsProfitBox.vue";
import StatsSection from "./StatsSection.vue";
import StatsCampaignsBox from "./StatsCampaignsBox.vue";

export default {
  name: "StatsCampaignsChart",
  components: {StatsCampaignsBox, StatsSection, StatsCampaignsProfitBox, StatsBox},
  props: {
    chart: {
      type: Object,
      required: true,
    },
    leadChartData: {
      type: Object,
      default: {},
    },
    contractedChartData: {
      type: Object,
      default: {},
    },
    closedChartData: {
      type: Object,
      default: {},
    },
  },
  computed: {
    costPerLead() {
      if (this.chart.leads === 0) return 0
      return parseFloat(this.chart.cost / this.chart.leads)
    },
    costPerContracted() {
      if (this.chart.contracted === 0) return 0
      return parseFloat(this.chart.cost / this.chart.contracted)
    },
    costPerClosed() {
      if (this.chart.closed === 0) return 0
      return parseFloat(this.chart.cost / this.chart.closed)
    },
    projectProfitRoi() {
      if (this.chart.cost === 0) return 0
      return parseFloat(((this.chart.projected_profit - this.chart.cost) / this.chart.cost) * 100)
    },
    projectProfitDollar() {
      if (this.chart.cost === 0) return 0
      return parseFloat(this.chart.projected_profit / this.chart.cost)
    },
    actualProfitRoi() {
      if (this.chart.cost === 0) return 0
      return parseFloat(((this.chart.actual_profit - this.chart.cost) / this.chart.cost) * 100)
    },
    actualProfitDollar() {
      if (this.chart.cost === 0) return 0
      return parseFloat(this.chart.actual_profit / this.chart.cost)
    },
  },
}
</script>

<style scoped lang="scss">

</style>
